import React from 'react';
import DynamicCardList from 'Components/ComponentLibrary/Organisms/DynamicCardList';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  root: {},
  subcategory: {
    marginTop: theme.spacing(2),
  },
  list: {
    marginLeft: theme.spacing(1),
  },
});

const ShoppingCartSelect = ({
  className,
  classes,
  options,
  refetchItems,
  onClickItem,
}) => {
  // Categorize the shopping cart items
  const {
    categorized,
    sortedCategories,
  } = React.useMemo(() => {
    const map = {};
    options.forEach(el => {
      const cat = el.attr('category');
      const subCat = el.attr('subCategory');
      if (!map[cat]) {
        map[cat] = {
          categoryOrdinal: el.attr('categoryOrdinal'),
          sortedSubCategories: {},
        };
      }
      if (!map[cat][subCat]) {
        map[cat][subCat] = [];
        map[cat].sortedSubCategories[subCat] = el.attr('subCategoryOrdinal');
      }
      map[cat][subCat].push(el);
    });

    // Sort categories based on ordinal
    const sortedCats = Object.keys(map).sort((a, b) => {
      if (map[a].categoryOrdinal < map[b].categoryOrdinal) return -1;
      if (map[a].categoryOrdinal > map[b].categoryOrdinal) return 1;
      return 0;
    });

    // Sort subcategories for each category based on ordinal
    Object.keys(map).forEach(cat => {
      const subCats = map[cat].sortedSubCategories;
      map[cat].sortedSubCategories = Object.keys(map[cat].sortedSubCategories).sort((a, b) => {
        if (subCats[a] < subCats[b]) return -1;
        if (subCats[a] > subCats[b]) return 1;
        return 0;
      });
    });

    return {
      categorized: map,
      sortedCategories: sortedCats,
    };
  }, [options]);

  return (
    <Box className={classNames(className, classes.root)}>
      {sortedCategories.map(category => {
        const subCategories = categorized[category].sortedSubCategories || [];
        return (
          <React.Fragment>
            <Typography color="primary" variant="h4" weight="bold" gutterBottom>{category}</Typography>
            {subCategories.map(subCategory => {
              const items = categorized[category][subCategory] || [];
              return (
                <div className={classes.subcategory}>
                  <Typography color="primary" variant="h6" gutterBottom>{subCategory}</Typography>
                  {items.map(resource => {
                    return (
                      <DynamicCardList
                        className={classes.list}
                        key={resource.id()}
                        name={resource.attr('label')}
                        items={resource.attr('items')?.resources()?.list() ? resource.attr('items')?.resources()?.list() : []}
                        onAdd={() => {
                          resource.withRelationship(fr.relationships.addEmptyItem.name, async (rel) => {
                            const response = await rel.link('related').post({}, { deprecatedAllowAlterOfRelation: true });
                            refetchItems(response);
                          },
                          () => null);
                        }}
                        onClickItem={onClickItem}
                        refetchItems={refetchItems}
                      />
                    );
                  })}
                </div>
              );
            })}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

ShoppingCartSelect.defaultProps = {
  className: null,
  options: [],
  onClickItem: undefined,
};

ShoppingCartSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  options: PropTypes.array,
  refetchItems: PropTypes.func.isRequired,
  onClickItem: PropTypes.func,
};

export default withStyles(styles)(ShoppingCartSelect);
